import React from "react";
import { useSelector } from "react-redux";
import AccountsPage from "../../components/dashboard/AccountsPage";
import {
  createOperator,
  deleteOperatorAccount,
  getSales,
  updateOperatorAccount,
} from "../../redux/actions/userActions";

const ROLES = [{ value: "sales", label: "Commercial" }];

function Sales() {
  const { sales } = useSelector((state) => state.users);

  return (
    <AccountsPage
      title="Commerciaux"
      lead="Les membres de l'équipe qui suivent les clients."
      accounts={sales}
      load={getSales}
      create={createOperator}
      update={updateOperatorAccount}
      remove={deleteOperatorAccount}
      roles={ROLES}
      emptyText="Aucun commercial pour le moment."
    />
  );
}

export default Sales;
